import '../code/code.css'
import React, {useState} from "react";
import ChevronIcon from "../../assets/ChevronIcon";

export function AccordionItemComponent({children, header}) {
    const [expanded, setExpanded] = useState(false);
    return (
        <>
            <button className={"accordionHeader" + (expanded ? " expanded" : "")}
                    onClick={() => setExpanded(!expanded)}>
                {header}<ChevronIcon className={"chevronIcon" + (expanded ? " expanded" : "")}/>
            </button>
            {expanded && <AccordionItemBody children={children}/>}
        </>
    );
}

function AccordionItemBody({children}) {
    return (
        <div className={"accordionBody"}>
            {children}
        </div>
    )
}
